import {
  FieldWrapper,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { Label } from '@commenda/kakashi/src/components/Label';
import { TParamValue } from '@commenda/types/src/workflow/dsl/values';
import {
  getDefaultFieldRefObj,
  isParamValueArray,
  isParamValueProvider,
} from './helpers';

enum ParamValueType {
  Provider = 'provider',
  Object = 'object',
  Array = 'array',
}

export const ParamValueTypeSwitcher = ({
  value,
  onChange,
}: {
  value: TParamValue;
  onChange: (v: TParamValue) => void;
}) => {
  const type: ParamValueType = isParamValueProvider(value)
    ? ParamValueType.Provider
    : isParamValueArray(value)
      ? ParamValueType.Array
      : ParamValueType.Object;

  const setParamValueType = (k: ParamValueType) => {
    if (k === type) return;
    if (k === ParamValueType.Provider) onChange(getDefaultFieldRefObj());
    if (k === ParamValueType.Object) onChange({});
    if (k === ParamValueType.Array) onChange([]);
  };

  return (
    <FieldWrapper>
      <Label>Value Type</Label>
      <Select value={type} onValueChange={setParamValueType}>
        <SelectTrigger className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ParamValueType.Provider}>Provider</SelectItem>
          <SelectItem value={ParamValueType.Object}>Object</SelectItem>
          <SelectItem value={ParamValueType.Array}>Array</SelectItem>
        </SelectContent>
      </Select>
    </FieldWrapper>
  );
};
